import { vDate } from '../common/directives/masks'

export default (Vue) => {
  Vue.directive('vdate', vDate)
}



// WEBPACK FOOTER //
// ./src/config/directives.js